import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { configureAuthApi, AuthProvider } from "@safers/auth";
import { useWHEPStore } from "@/lib/cctv";
import { registerSW } from "virtual:pwa-register";

import "pretendard/dist/web/variable/pretendardvariable.css";
import { App } from "./App";
import "./styles/globals.css";

const contextPath = import.meta.env.VITE_CONTEXT_PATH || "";
const apiBasePath = import.meta.env.VITE_API_BASE_PATH ?? contextPath;

// 401 + refresh 실패 시 store reset → ProtectedRouter가 returnUrl 보존하여
// /login으로 자동 이동. 콜백은 헬퍼가 기본 바인딩.
configureAuthApi({ baseURL: `${apiBasePath}/api` });

useWHEPStore.getState().initialize();

// PWA Service Worker 등록 (자동 업데이트)
registerSW({ immediate: true });

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter basename={contextPath || "/"}>
      <AuthProvider loginPath="/login">
        <App />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>
);
